/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';

var CommentAltIcon = createIcon({
  name: 'CommentAltIcon',
  height: 512,
  width: 512,
  svgPath: 'M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64z',
  yOffset: '',
  xOffset: '',
  transform: ''
});

export default CommentAltIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-icons/dist/esm/icons/comment-alt-icon.js
// module id = 490
// module chunks = 0